<template>
    <div>
        <el-card>
            <div class="tableBox">
                <div>
                    <div>
                        <span>特殊统计</span>
                        <span>事件管理统计</span>
                    </div>
                    <img src="../../../../assets/icon_logo.png">
                </div>
                <div>
                    <div>
                        <div style="position:relative;height:20px;">
                            <div class="helpDiv" style="position: absolute;top:-20px">
                                <b class="helpI"></b>
                                <a href="https://wiki.autoai.com/pages/viewpage.action?pageId=26156916"
                                target="_blank"
                                class="helpA">
                                    帮助指引
                                </a>
                            </div>
                        </div>
                        <el-form :inline="true" class="search-form">
                            <el-form-item label="">
                                <el-date-picker
                                    ref="dataPicker"
                                    @change="changeData"
                                    v-model="value"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-form-item>
                            <el-button type="primary" @click="selectData">修改时间</el-button>
                            <el-button type="primary" @click="getExcel">导出excel</el-button>
                        </el-form>
                    </div>
                    <div class="tableClass">
                        <div>
                            <el-table
                                :data="tableData">
                                <el-table-column prop="complete" label="解决事件数"></el-table-column>
                                <el-table-column prop="total" label="事件总数"></el-table-column>
                                <el-table-column prop="rate" label="完成率"></el-table-column>
                            </el-table>
                        </div>
                        <div ref="myChart"></div>
                    </div>
                </div>
                <div>
                    <div>
                        <span>生成时间:</span>
                        <span>{{getMes.generateTime}}</span>
                    </div>
                    <span>itsmops.autoai.com</span>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>

    import services from '../report.service';
    import { export_json_to_excel } from '../../../../core/utils/Export2Excel';
    export default {
        data: function () {
            return {
                tableData: [],
                value:'',
                options:{
                    tooltip : {
                        formatter: function(params, ticket, callback){
                            if(params.data[0]=='完成率'){
                                return params.data[0]+':'+params.data[1]+'%';
                            }else{
                                return params.data[0]+':'+params.data[1]
                            }
                        }
                    },
                    legend: {},
                    dataset:{},
                    dataZoom:[
                        {
                            type: 'inside',
                            xAxisIndex: 0,
                        },
                        {
                            type: 'slider',
                            xAxisIndex: 0,
                        },
                        {
                            type: 'inside',
                            yAxisIndex: 0,
                        },
                        {
                            type: 'slider',
                            yAxisIndex: 0,
                        },
                    ],
                    xAxis: [{type: 'category',}],
                    yAxis: [{}],
                    series: [
                        {
                            type:'bar',
                            label: {
                                normal: {
                                    formatter: function(params){
                                        if(params.data[0]=='完成率'){
                                            return params.data[1]+'%';
                                        }else{
                                            return params.data[1]
                                        }
                                    },
                                    show:true,
                                    position: 'top'
                                }
                            },
                        },
                    ]
                },
                getMes:{},
            }
        },
        mounted(){
            this.value = services.getDefaultData();
            this.getData();
        },
        methods:{
            getExcel(){
                let header = [];
                let filterVal = [];
                header = ['解决事件数', '事件总数', '完成率'];
                filterVal = ['complete', 'total', 'rate'];
                const list = this.tableData;
                const data = this.formatJson(filterVal, list);
                export_json_to_excel({header,data,filename:`事件管理统计${this.value[0]}—${this.value[1]}`});
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            getData(){//获取数据
                let params = {
                    startTime: this.value[0],
                    stopTime: this.value[1],
                }
                services.getEventCompleteRate(params).then(res=>{
                    res.graphData.unshift(["product","",]);
                    res.tableData.forEach(item=>{
                        item.rate =  (Number(item.rate)*100).toFixed(2)+'%'
                    })
                    res.graphData.forEach(item=>{
                        if(item[0] == '完成率'){
                            item[1] = (Number(item[1])*100).toFixed(2);
                        }
                    })
                    this.getMes = res;
                    this.tableData = res.tableData;
                    this.getEcharts();
                })
            },
            selectData(){//点击修改日期 日期控件自动聚焦
                let selData = this.$refs.dataPicker;
                selData.focus();
            },
            changeData(){//选择日期
                this.getData();
            },
            getEcharts(item){//实例化图标
                let myChart = this.$echarts.init(this.$refs.myChart);
                this.options.dataset.source = this.getMes.graphData;
                myChart.setOption(this.options);
            },
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .tableClass{
        display: flex;
        &>div:nth-child(1){
            width: 40%;
        }
        &>div:nth-child(2){
            width: 60%;
            height:400px;
        }
    }
</style>
